export default class ShopCartData {
    constructor(param) {
        var me = this;
        let now = new Date();

        me.id = 0;
        me.riferimento = "";
        me.$loki = '';
        me.clientId = 0;
        me.userId = 0;
        me.vostroRif = "";
        me.tipoOrdine = 'Standard'; //param.$Jed.firstUpperTranslate('Standard'); 
        me.note = "";
        me.scontoBase = 0;
        me.importo = 0;
        me.statoOrdine = param.$root.getFirstOrderStatus() ? param.$root.getFirstOrderStatus().id : null;
        me.valutaOrdine = param.$root.token.valuta;
        me.language = param != null ? param.$root.lang.lang : param.$root.token.defaultLang; 
        me.dataOrdine = now;
        me.dataModifica = now;

        me.anagraficaCliente = {};
        me.anagraficaCliente.ragioneSociale = "";
        me.anagraficaCliente.codiceFiscale = "";
        me.anagraficaCliente.partitaIva = "";
        me.anagraficaCliente.nomeTitolare = "";
        me.anagraficaCliente.indirizzo = null;
        me.anagraficaCliente.idIndirizzo = null;
        me.anagraficaCliente.cap = null;
        me.anagraficaCliente.localita = null;
        me.anagraficaCliente.provincia = null;
        me.anagraficaCliente.zonaCliente = "";
        me.anagraficaCliente.regione = null;
        me.anagraficaCliente.nazione = null;
        me.anagraficaCliente.telefono = null;
        me.anagraficaCliente.fax = null;
        me.anagraficaCliente.mail = "";    

        me.prodotti = [];

        me.consegna = {}
        me.consegna.consegnaRichiesta = "";
        me.consegna.tipoPorto = ""; //allowNull: false quindi metto di default stringa vuota
        me.consegna.tipoPortoDes = "";
        me.consegna.tipoPortoFre = "";
        me.consegna.idIndirizzo = null;
        me.consegna.nominativo = ""; 
        me.consegna.indirizzo = ""; 
        me.consegna.localita = ""; 
        me.consegna.cap = "";
        me.consegna.sigPro = "";
        me.consegna.nazione = "";  
        me.consegna.provincia = "";
        me.consegna.regione = "";  

        me.altroindirizzoconsegna = {}
        me.altroindirizzoconsegna.indirizzo = ""; 
        me.altroindirizzoconsegna.idIndirizzo = "";
        me.altroindirizzoconsegna.localita = ""; 
        me.altroindirizzoconsegna.cap = "";
        me.altroindirizzoconsegna.nazione = "";  
        me.altroindirizzoconsegna.provincia = "";
        me.altroindirizzoconsegna.regione = "";  
        
        me.richiedente = {}
        me.richiedente.nomecognome = ""
        me.richiedente.mail = ""
        me.richiedente.fax = ""
        me.richiedente.telefono = ""
        me.richiedente.id = ""

        me.altrorichiedente = {}
        me.altrorichiedente.nomecognome = ""
        me.altrorichiedente.mail = ""
        me.altrorichiedente.fax = ""
        me.altrorichiedente.telefono = ""
        me.altrorichiedente.id = ""

        me.spedizione = {}
        me.spedizione.tipoSpedizione = ""; //allowNull: false quindi metto di default stringa vuota
        me.spedizione.tipoSpedizioneDes = ""; 
        me.spedizione.accorpaSpedizione = null;
        
    }
}



// WEBPACK FOOTER //
// ./src/components/views/shopcart/ShopCartData.js